<script setup>
import errorSvg from '@/assets/images/error.svg'
</script>

<template>
  <img alt="" :src="errorSvg" class="error-icon">
</template>
